console.log('front simulation.js');

let TOOLS = TOOLS || {};

/**
 * ローン返済シミュレーション
 */
TOOLS.SIMULATION = {

  init: function() {
    var self = this;

    // 毎月返済シミュレーション
    self.calc();

    // 借入可能額シミュレーション
    self.calcBack();

    // 月々の返済額から探す
    self.initSearchMonthlyRepayment();
  },

  /**
   * 毎月返済シミュレーション
   */
  calc: function() {
    var self = this;

    var trigger = $('.js-calc');
    if (trigger.length) {
      trigger.on('click', function() {
        var loan = parseFloat($('#loan').val().split(",").join("")) * 10000;
        var interest = parseFloat($('#interest').val().split(",").join(""));
        var payment = parseFloat($('#payment').val().split(",").join("")) * 12;
        var income = parseFloat($('#income').val().split(",").join("")) * 10000;
        var bonus;
        if (!($('#bonus').val().split(",").join("")) || !($('#bonus').val().split(",").join("").match(/^[0-9]/))) {
          bonus = 0;
        } else {
          bonus = parseFloat($('#bonus').val().split(",").join("")) * 10000;
        }

        var result = self.calcMonthlyRepaymentAmount(loan, interest, payment, income, bonus);

        //毎月の返済額
        $('#monthly').text(self.formatNumber(result.monthly));

        //ボーナス分の返済額
        $('#bonusmonth').text(self.formatNumber(result.bonusmonth));

        //1年間の返済額
        $('#yearly').text(self.formatNumber(result.yearly));

        // 返済負担率
        $('#hutanritsu').text(result.debtToIncomeRatio);

        if ($('#monthly').text() == "NaN") { $('#monthly').text(0); }
        if ($('#bonusmonth').text() == "NaN") { $('#bonusmonth').text(0); }
        if ($('#yearly').text() == "NaN" ) { $('#yearly').text(0); }
        if ($('#hutanritsu').text() == "NaN" ) { $('#hutanritsu').text(0); }
      });
    }
  },

  /**
   * 借入可能額シミュレーション
   */
  calcBack: function() {
    var self = this;

    var trigger = $('.js-calc-back');
    if (trigger.length) {
      trigger.on('click', function() {
        var monthlydebt = parseFloat($('#monthlydebt').val().split(",").join("")) * 10000;
        var monthlyinterest = parseFloat($('#monthlyinterest').val().split(",").join(""));
        var monthlypayment = parseFloat($('#monthlypayment').val().split(",").join("")) * 12;
        var nensyu = parseFloat($('#nensyu').val().split(",").join("")) * 10000;
        var monthlybonus;
        if (!($('#monthlybonus').val().split(",").join("").match(/[0-9]+/)) || !($('#monthlybonus').val().split(",").join(""))) {
          monthlybonus = 0;
        } else {
          monthlybonus = parseFloat($('#monthlybonus').val().split(",").join("")) * 10000;
        }

        var result = self.calcLoanableAmount(monthlydebt, monthlyinterest, monthlypayment, nensyu, monthlybonus);

        // ボーナス分
        $('#bonusamount').text(self.formatNumber(Math.round(result.bonus) * 10000));

        // 借入金額
        $('#debtamount').text(self.formatNumber(Math.round(result.debt) * 10000));

        // 1年間の返済額
        $('#hensai').text(self.formatNumber(Math.round(result.payment)));

        // 返済負担率
        $('#hensaihutanritsu').text(Math.round(result.debtToIncomeRatio * 100) / 100);

        if ($('#bonusamount').text() == "NaN" ) { $('#bonusamount').text(0); }
        if ($('#debtamount').text() == "NaN" ) { $('#debtamount').text(0); }
        if ($('#hensai').text() == "NaN" ) { $('#hensai').text(0); }
        if ($('#hensaihutanritsu').text() == "NaN" ) { $('#hensaihutanritsu').text(0); }
      });
    }
  },

  /**
   * 月々の返済額から探す
   */
  initSearchMonthlyRepayment: function() {
    var self = this;

    if ($('#cond_price_min').length && $('#cond_price_max').length && $('#period').length && $('#interest').length) {
      var priceMin = parseFloat($('#cond_price_min').val());
      var priceMax = parseFloat($('#cond_price_max').val());
      var period = parseFloat($('#period').val()) * 12;
      var interest = parseFloat($('#interest').val());

      self.setMonthlyRepayment(priceMin, priceMax, interest, period);

      $('#cond_price_min').on('change', function() {
        priceMin = parseFloat($(this).val());
        self.setMonthlyRepayment(priceMin, priceMax, interest, period);
        self.changeStatus(priceMin, 'min');
      });

      $('#cond_price_max').on('change', function() {
        priceMax = parseFloat($(this).val());
        self.setMonthlyRepayment(priceMin, priceMax, interest, period);
        self.changeStatus(priceMax, 'max');
      });

      $('#period').on('change', function() {
        period = parseFloat($(this).val()) * 12;
        self.setMonthlyRepayment(priceMin, priceMax, interest, period);
      });

      $('#interest').on('change', function() {
        interest = parseFloat($(this).val());
        self.setMonthlyRepayment(priceMin, priceMax, interest, period);
      });

      // 検索ボタン押下時
      $('.js-form-cond-payment-submit').on('click', function() {
        let $form = $('.js-form-cond-payment');
        // 値をhiddenに設定
        const pf = $form.attr('data-price-from');
        const pt = $form.attr('data-price-to');
        if (pf) $form.append($('<input>', {type: 'hidden', name: 'price_from', value: pf}));
        if (pt) $form.append($('<input>', {type: 'hidden', name: 'price_to', value: pt}));

        // submit先を設定
        const url = $(this).attr('data-action');
        $form.attr('action', url);
      });
    }
  },

  /**
   * 「購入物件の価格の目安」を設定
   * @param {*} priceMin
   * @param {*} priceMax
   * @param {*} interest
   * @param {*} period
   */
  setMonthlyRepayment: function(priceMin, priceMax, interest, period) {
    var self = this;

    var resultMin = self.calcLoanableAmount(priceMin, interest, period, 0, 0);
    var resultMax = self.calcLoanableAmount(priceMax, interest, period, 0, 0);

    var rowMinDebt = resultMin.debt;
    var rowMaxDebt = Math.round(resultMax.debt);

    var minDebt = self.divideDebt(rowMinDebt);
    var maxDebt = self.divideDebt(rowMaxDebt);

    $('#min-debt').text(self.formatNumber(minDebt));
    $('#max-debt').text(self.formatNumber(maxDebt));

    // 検索条件用に数値を控える
    if ($('.js-form-cond-payment').length) {
      $('.js-form-cond-payment').attr('data-price-from', minDebt);
      $('.js-form-cond-payment').attr('data-price-to', maxDebt);
    }
  },

  /**
   * ルールに合わせて丸め込み
   * ※7000万までは500万区切り、6000万以降は1000万区切り
   * @param {*} rowDebt
   * @returns
   */
  divideDebt: function(rowDebt) {
    var self = this;

    var debt = Math.round(rowDebt);

    if (debt < 1000) {
      // 1000万未満は1000万固定
      return 1000;
    } else if (debt >= 1000 && debt < 7000) {
      // 500万単位なので2倍して1000万単位にした上で下3桁削って四捨五入した後に桁戻して1/2に戻す
      return Math.round(debt * 2 / 1000) * 1000 / 2;
    } else if (debt >= 7000 && debt < 10000) {
      // 7000万以降は1000万単位なのでそのまま3桁削って四捨五入した後に桁戻す
      return Math.round(debt / 1000) * 1000;
    } else if (debt >= 10000) {
      // 1億以上は10000固定
      return 10000;
    }
  },

  /**
   * 毎月返済シミュレーションの算出
   * @param {*} loan
   * @param {*} interest
   * @param {*} payment
   * @param {*} income
   * @param {*} bonus
   */
  calcMonthlyRepaymentAmount: function(loan, interest, payment, income, bonus) {
    //毎月の返済額
    var monthlyInterest = interest / 100 / 12;
    var monthly = parseInt((loan - bonus) * monthlyInterest * Math.pow((1 + monthlyInterest), payment) / (Math.pow((1 + monthlyInterest), payment) - 1));

    //ボーナス分の返済額
    var bonusmonthInterest = interest / 100 / 2;
    var bonusmonth = parseInt(bonus * bonusmonthInterest * Math.pow((1 + bonusmonthInterest), payment / 6) / (Math.pow((1 + bonusmonthInterest), payment / 6) - 1));

    //1年間の返済額
    var yearly = monthly * 12 + bonusmonth * 2;

    // 返済負担率
    var hutanritsu = (monthly * 12 + bonusmonth * 2) / income * 100;
    debtToIncomeRatio = Math.round(hutanritsu * 100) / 100;

    return data = {
      monthly: monthly,
      bonusmonth: bonusmonth,
      yearly: yearly,
      debtToIncomeRatio: debtToIncomeRatio
    }
  },


  /**
   * 借入可能額を算出
   * @param {*} monthlyDebt
   * @param {*} monthlyInterest
   * @param {*} monthlyPayment
   * @param {*} annualIncome
   * @param {*} bonus
   * @returns
   */
  calcLoanableAmount: function(monthlydebt, monthlyinterest, monthlypayment, nensyu, monthlybonus) {
    // ボーナス分
    var bonusmonthInterest = monthlyinterest / 100 / 2;
    var bonusamount = monthlybonus / 10000 / bonusmonthInterest / Math.pow((1 + bonusmonthInterest), monthlypayment / 6) * (Math.pow((1 + bonusmonthInterest), monthlypayment / 6) - 1);

    // 借入金額
    var monthlyInterest = monthlyinterest / 100 / 12;
    var debtamount = (monthlydebt / monthlyInterest / Math.pow((1 + monthlyInterest), monthlypayment) * (Math.pow((1 + monthlyInterest), monthlypayment) -1 )) / 10000 + bonusamount;

    // 1年間の返済額
    var hensai = monthlydebt * 12 + monthlybonus * 2;

    // 返済負担率
    var hensaihutanritsu = hensai / nensyu * 100;

    return data = {
      bonus: bonusamount,
      debt: debtamount,
      payment: hensai,
      debtToIncomeRatio: hensaihutanritsu
    }
  },

  // 数値のカンマのフォーマット
  formatNumber: function(num) {
    return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  },

  /**
   * 選択できる範囲を制御
   * 最小値を選択中に最大値より大きい値は選択できない
   * 最大値を選択中に最小値より小さい値は選択できない
   * @param {*} num         変更された値
   * @param {*} position    最小値、最大値のどちらか
   */
  changeStatus: function(num, position) {
    var self = this;
    if (position === 'min') {
      $('#cond_price_max option').each(function(key, value) {
        $(value).prop('disabled', false);
        if ($(value).attr('value') < num) {
          $(value).prop('disabled', true);
        }
      });
    } else {
      $('#cond_price_min option').each(function(key, value) {
        $(value).prop('disabled', false);
        if ($(value).attr('value') > num) {
          $(value).prop('disabled', true);
        }
      });
    }
  },
};

$(function() {
  TOOLS.SIMULATION.init();
})
